





















































import toastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import i18n from "@/libs/i18n";
import { useChatsStore } from "@/store/useChatsStore";
import { useTagsStore } from "@/store/useTagsStore";
import { styleByColor, textColorByBackgroundColor } from "@/utils/color";
import { TagDto } from "@saysimple-platform/dtos";
import { computed, defineComponent } from "@vue/composition-api";
import {
    BAlert,
    BDropdown,
    BDropdownItem,
    BDropdownText,
    BFormGroup,
    BFormTag,
    BFormTags,
    BIcon,
    BOverlay,
} from "bootstrap-vue";
import { useToast } from "vue-toastification/composition";

export default defineComponent({
    components: {
        BAlert,
        BDropdown,
        BDropdownItem,
        BDropdownText,
        BFormGroup,
        BFormTag,
        BFormTags,
        BIcon,
        BOverlay,
    },
    setup() {
        const tagsStore = useTagsStore();
        const toast = useToast();

        const linkTag = (tag: TagDto): void => {
            tagsStore
                .linkTag(tag)
                .then(() => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("entities.tags.Tags"),
                            text: i18n.t("entities.tags.tag-linked-success"),
                            icon: "check",
                            variant: "success",
                        },
                    });
                })
                .catch(() => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("entities.tags.Tags"),
                            text: i18n.t("entities.tags.tag-linked-error"),
                            icon: "times",
                            variant: "danger",
                        },
                    });
                });
        };

        const unlinkTag = (tag: TagDto): void => {
            tagsStore
                .unlinkTag(tag)
                .then(() => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("entities.tags.Tags"),
                            text: i18n.t("entities.tags.tag-linked-success"),
                            icon: "check",
                            variant: "success",
                        },
                    });
                })
                .catch(() => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("entities.tags.Tags"),
                            text: i18n.t("entities.tags.tag-linked-error"),
                            icon: "times",
                            variant: "danger",
                        },
                    });
                });
        };

        const selectableTags = computed((): TagDto[] => {
            const linkedTagIds = tagsStore.activeChatTags?.map((linkedTag) => linkedTag.id);
            return tagsStore.tags.filter((tag) => !linkedTagIds.includes(tag.id));
        });

        const chatsStore = useChatsStore();
        return {
            chatsStore,
            linkTag,
            selectableTags,
            styleByColor,
            tagsStore,
            textColorByBackgroundColor,
            unlinkTag,
        };
    },
});
